module.exports = __webpack_public_path__ + "img/broadcast tower-white-matte.091d1990.gif";